<div #sectionOffers class="d-flex flex-column row-gap-3 row-gap-xxl-4" id="sectionOffers">
  <ng-template
    #offersGrid
    let-offers="offers"
    let-limit="limit"
    let-total="total"
    let-isExpanded="isExpanded"
    let-btnId="btnId"
  >
    <section class="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-3 g-md-4 g-xxl-5">
      @if (!isLoading()) {
        @for (offer of offers; track offer.destinationCode) {
          @defer (on viewport; prefetch on idle) {
            <app-new-card-offer
              class="col"
              [urlImage]="offer.image"
              [title]="offer.destination | titlecase"
              [description]="'Desde Lima'"
              [destinationCode]="offer.destinationCode"
              [destinationName]="offer.destination"
              [price]="offer.rate"
              [exchange]="offer.currencyExchange?.amount ?? 0"
            ></app-new-card-offer>
          } @placeholder {
            <div class="col">
              <ng-container *ngTemplateOutlet="loading"></ng-container>
            </div>
          }
        } @empty {
          <div class="col-12 text-center py-4">No se encontraron ofertas disponibles.</div>
        }
      } @else {
        <ng-container *ngTemplateOutlet="loading"></ng-container>
      }
    </section>

    @if (isLoading() || total > initialItems()) {
      <div class="text-center mt-4 mt-xxl-5">
        <app-button
          (buttonClick)="toggleLimit(limit, total)"
          [buttonId]="btnId"
          [isDisabled]="isLoading()"
          buttonClass="mx-auto"
          buttonStyle="outline"
        >
          {{ isExpanded ? "Ver menos" : "Ver más ofertas" }}
        </app-button>
      </div>
    }
  </ng-template>

  <ul
    #nav="ngbNav"
    [activeId]="1"
    ngbNav
    class="nav nav-underline column-gap-0 column-gap-md-4 column-gap-xxl-5 justify-content-between justify-content-md-start px-2 px-md-3 mb-1 mb-md-2"
  >
    <li [ngbNavItem]="1">
      <a ngbNavLink class="lh-sm py-2">Vuelos Nacionales</a>
      <ng-template ngbNavContent>
        <ng-container
          *ngTemplateOutlet="
            offersGrid;
            context: {
              offers: domesticOffers(),
              limit: domesticLimit,
              total: facade.domesticOffers().length,
              isExpanded: isDomesticExpanded(),
              btnId: 'btn-domestic-toggle'
            }
          "
        ></ng-container>
      </ng-template>
    </li>
    <li [ngbNavItem]="2">
      <a ngbNavLink class="lh-sm py-2">Vuelos Internacionales</a>
      <ng-template ngbNavContent>
        <ng-container
          *ngTemplateOutlet="
            offersGrid;
            context: {
              offers: internationalOffers(),
              limit: internationalLimit,
              total: facade.internationalOffers().length,
              isExpanded: isInternationalExpanded(),
              btnId: 'btn-international-toggle'
            }
          "
        ></ng-container>
      </ng-template>
    </li>
  </ul>

  <div [ngbNavOutlet]="nav"></div>

  <ng-template #loading>
    @for (_ of skeletonItems(); track $index) {
      <app-card-placeholder imgTopStyle="md" class="col"></app-card-placeholder>
    }
  </ng-template>
</div>
